import { createStyles, makeStyles } from '@material-ui/core';
import { Theme } from '@maas-components/styles';

const styles = (theme: Theme) => {
    return createStyles({
        fontSizeDefault: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(24),
        },
        fontSizeXsmall: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(12),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(18),
        },
        fontSizeSmall: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(14),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(24),
        },
        fontSizeMedium: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(20),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(30),
        },
        fontSizeLarge: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(26),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(36),
        },
        fontSizeXlarge: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(32),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(42),
        },
        fontSizeXxlarge: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(40),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(46),
        },
        fontSizeXxxlarge: {
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(48),
            letterSpacing: 0,
            lineHeight: theme.typography.pxToRem(52),
        },
        fontWeightRegular: {
            fontWeight: theme.typography.fontWeightRegular as number,
        },
        fontWeightMedium: {
            fontWeight: theme.typography.fontWeightMedium as number,
        },
        fontWeightBold: {
            fontWeight: theme.typography.fontWeightBold as number,
        },
        fontWeightXbold: {
            fontWeight: 900,
        },
    });
};

export default makeStyles(styles, { name: 'MuiTypographyLegacy' });
